var _a, _b, _c, _d, _e;
import { OrganizationRole, AddressType, PhoneNumberUse, EmailUse, Loa, } from "./admin-gql";
import i18next from "i18next";
var roleDisplayNames = (_a = {},
    _a[OrganizationRole.ADMIN] = "cc.display.names.administrator",
    _a[OrganizationRole.ISSUER] = "cc.display.names.issuer",
    _a[OrganizationRole.USER] = "cc.display.names.member",
    _a);
var addressTypeDisplayNames = (_b = {},
    _b[AddressType.HOME] = "cc.display.names.home",
    _b[AddressType.OFFICIAL] = "cc.display.names.official",
    _b[AddressType.OTHER] = "cc.display.names.other",
    _b);
var phoneUseDisplayNames = (_c = {},
    _c[PhoneNumberUse.ONLY_SMS_CODES] = "cc.display.names.smsLoginOnly",
    _c[PhoneNumberUse.PRIVATE] = "cc.display.names.privat",
    _c[PhoneNumberUse.PROFESSIONAL] = "cc.display.names.professionAndStudies",
    _c);
var emailUseDisplayNames = (_d = {},
    _d[EmailUse.SKOLID_INTERNAL] = "cc.display.names.logInOnly",
    _d[EmailUse.PRIVATE] = "cc.display.names.privat",
    _d[EmailUse.PROFESSIONAL] = "cc.display.names.professionAndStudies",
    _d);
export var loaDisplayNames = (_e = {},
    _e[Loa.ZERO] = {
        name: "Låg",
    },
    _e[Loa.ONE] = {
        name: "Bas",
    },
    _e[Loa.TWO] = {
        name: "Hög",
    },
    _e[Loa.THREE] = {
        name: "Mycket hög",
    },
    _e[Loa.MAX] = {
        name: "Mycket hög",
    },
    _e);
export function getRoleDisplayNames(key) {
    return i18next.t(roleDisplayNames[key]);
}
export function getAddressTypeDisplayNames(key) {
    return i18next.t(addressTypeDisplayNames[key]);
}
export function getPhoneUseDisplayNames(key) {
    return i18next.t(phoneUseDisplayNames[key]);
}
export function getEmailUseDisplayNames(key) {
    return i18next.t(emailUseDisplayNames[key]);
}
//# sourceMappingURL=displayNames.js.map